import React from 'react';
import itemTypeToEmoji from 'util/itemTypeToEmoji';
import 'styles/item/ItemIcon.css';
import KeyButtSvg from 'util/svg/getKeyButtSvg';

const ItemIcon = ({lootItem, textSize = 1}) => {
    const rarity = itemTypeToEmoji.getRarity(lootItem);
    return (
        <div className="item-container">
            <KeyButtSvg rarity={rarity} height={`${2 * textSize}em`} width={`${2 * textSize}em`}/>
            <span className={'item-emoji-text'}
                  style={{fontSize: `${textSize}em`}}>
                {itemTypeToEmoji[lootItem].emoji || lootItem}
            </span>
        </div>
    );
};

export default ItemIcon;